import { useCallback } from "react"
import { useMutation, UseMutationConfig } from "react-relay"
import { graphql } from "relay-runtime"
import { useUpdateChatStatusMutation as useUpdateChatStatusMutationType } from "@/modules/admin/capacity/services/__generated__/useUpdateChatStatusMutation.graphql"

const mutation = graphql`
  mutation useUpdateChatStatusMutation($input: UpdateChatStatusInput!) {
    updateChatStatus(input: $input) {
      chatStatus {
        id
        language
        canCreateMedicalChats
        canCreateAdministrativeChats
        changedAt
        changedBy
      }
    }
  }
`
const useUpdateChatStatusMutation = () => {
  const [commit, isFlight] = useMutation<useUpdateChatStatusMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useUpdateChatStatusMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useUpdateChatStatusMutation }
